// Added by Jonghyung Lee on 2021-01-13
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import { FC } from 'react'

import { makeStyles, Theme, createStyles } from '@material-ui/core/styles'
import { Drawer as MaterialDrawer, DrawerProps as MaterialDrawerProps } from '@material-ui/core'

export interface DrawerProps extends MaterialDrawerProps {}

const Drawer: FC<DrawerProps> = ({ anchor = 'right', open, children, ...props }) => {
  const classes = useStyles()
  return (
    <MaterialDrawer
      {...props}
      className={classes.drawer}
      variant="temporary"
      anchor={anchor}
      open={open}
      classes={{ paper: classes.drawerPaper }}
    >
      {children}
    </MaterialDrawer>
  )
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    drawer: {
      width: '400px',
      flexShrink: 0,
    },
    drawerPaper: {
      width: '400px',
      top: '48px',
      maxHeight: 'calc(100vh - 80px)',
      padding: theme.spacing()
    },
  })
)

export default Drawer
